/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerUnlockHashDto } from '../models/EntityModelResponseContainerUnlockHashDto';
import type { PagedModelEntityModelUnlockHashDto } from '../models/PagedModelEntityModelUnlockHashDto';
import type { PagedResourcesAssemblerUnlockHashDto } from '../models/PagedResourcesAssemblerUnlockHashDto';
import type { UnlockHashDto } from '../models/UnlockHashDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UnlockHashControllerService {
    /**
     * @returns PagedModelEntityModelUnlockHashDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        page,
        size = 500,
        sort,
    }: {
        assembler: PagedResourcesAssemblerUnlockHashDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelUnlockHashDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/unlock_hashes',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        internalDeviceName,
    }: {
        internalDeviceName: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/unlock_hashes/{internalDeviceName}',
            path: {
                'internalDeviceName': internalDeviceName,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerUnlockHashDto OK
     * @throws ApiError
     */
    public static updateOrCreate({
        internalDeviceName,
        requestBody,
    }: {
        internalDeviceName: string,
        requestBody: UnlockHashDto,
    }): CancelablePromise<EntityModelResponseContainerUnlockHashDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/unlock_hashes/{internalDeviceName}',
            path: {
                'internalDeviceName': internalDeviceName,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
